<template>
  <div class="middleText">
    <el-row :gutter="20" type="flex" justify="space-between">
      <el-col :xs="24" :sm="20" :md="8" :lg="8" :xl="8" v-for="(item, index) in list" :key="index">
        <!-- <div class="grid-content bg-purple"></div> -->
        <div class="middleText-item">
          <img class="middleText-icon" :src="item.img" />
          <div class="middleText-text">
            <div class="middleText-text-title">{{ item.title }}</div>
            <div class="middleText-text-desc">{{ item.desc }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "middleText",
  data() {
    return {
      list: [
        {
          img: require("@/assets/icon/Bell.png"),
          // title: this.$t("m.hours"),
          title: "24/7 Customer Support",
          desc: "A dedicated Customer Support team is available 24/7 to answer any queries you may have.",
        },
        {
          img: require("@/assets/icon/Safety.png"),
          title: "Safe and Secure Transactions",
          desc: "Protect your personal information and ensure safe and secure transactions.",
        },
        {
          img: require("@/assets/icon/lowPrice.png"),
          title: "Global Competitive Price",
          desc: "Our mission is to make it easy for you to find and compare the best flight deals.",
        },
      ],
    };
  },
  computed: mapState({
    pageConfig: (state) => state.common.pageConfig,
  }),
};
</script>

<style lang="scss" scoped>
@import "./middleText.scss";
@import "./mmiddleText.scss";
</style>
